// client/utils/themeClasses.js
// Dark-only Hilfsklassen. Parameter `isDark` bleibt aus API-Stabilität optional erhalten, wird ignoriert.

/**
 * @param {boolean} [_isDark] ignoriert
 */
export const tw = {
  page: (_isDark) => "bg-gradient-to-br from-[#05070c] via-[#0a1020] to-[#0a1a32]",

  glass: (_isDark) => "bg-white/5 border-white/10 backdrop-blur",

  card: (_isDark) => "bg-[#0b1324]/60 border-white/10",

  cardHover: (_isDark) => "hover:border-blue-500/40 hover:shadow-xl",

  textPrimary: (_isDark) => "text-white",
  textSecondary: (_isDark) => "text-blue-100/90",
  textMuted: (_isDark) => "text-blue-200/80",
  textFaint: (_isDark) => "text-blue-200/60",

  heading: (_isDark) => "text-blue-100",
  subheading: (_isDark) => "text-blue-200/80",

  input: (_isDark) =>
    "bg-black/25 border-white/15 text-white placeholder:text-blue-200/40",

  inputFocus: (_isDark) => "focus:border-blue-400 focus:ring-blue-400/30",

  btnPrimary: () => "bg-blue-600 text-white hover:bg-blue-700",

  btnSecondary: (_isDark) => "bg-white/10 text-blue-100 border-white/15 hover:bg-white/15",

  btnGhost: (_isDark) => "text-blue-200 hover:bg-white/10",

  badge: (_isDark) => "bg-blue-500/10 text-blue-300 border-blue-400/20",

  statusSuccess: () => "bg-green-500/15 text-green-500 border-green-500/30",
  statusWarning: () => "bg-amber-500/15 text-amber-500 border-amber-500/30",
  statusDanger: () => "bg-red-500/15 text-red-500 border-red-500/30",
  statusInfo: () => "bg-blue-500/15 text-blue-500 border-blue-500/30",

  divider: (_isDark) => "border-white/10",

  scrollbar: (_isDark) => "[&::-webkit-scrollbar-thumb]:bg-white/20",

  tableHeader: (_isDark) => "bg-white/5 text-blue-200",

  tableRow: (_isDark) => "border-white/10 hover:bg-white/5",

  overlay: (_isDark) => "bg-black/70",

  skeleton: (_isDark) => "bg-white/10",

  topBar: (_isDark) => "bg-white/5 border-white/10",
};

/**
 * Kombiniert mehrere Klassen (wie clsx/cn)
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default tw;
